module.exports = __webpack_public_path__ + "static/media/7dc.43e9e727.png";